import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialog } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { TranslocoModule } from "@jsverse/transloco";
import { AuthService } from "app/core/auth/auth.service";
import { TenantOption } from "app/core/auth/tenant.types";
import { Subject, takeUntil } from "rxjs";
import { TenantSwitchModalComponent } from "./tenant-switch-modal.component";

@Component({
  selector: "app-tenant-switch",
  template: `
    <button *ngIf="hasMultipleTenants" mat-button (click)="openSwitchModal()" class="flex items-center">
      <mat-icon class="icon-size-5 mr-2" [svgIcon]="'heroicons_outline:building-office-2'"></mat-icon>
      <span class="truncate max-w-40">{{ current?.name }}</span>
    </button>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, MatButtonModule, MatIconModule, TranslocoModule],
})
export class TenantSwitchComponent implements OnInit, OnDestroy {
  current: TenantOption | null = null;
  hasMultipleTenants = false;

  private _authService = inject(AuthService);
  private _dialog = inject(MatDialog);
  private _changeDetectorRef = inject(ChangeDetectorRef);
  private _unsubscribeAll = new Subject<void>();

  ngOnInit(): void {
    this._authService
      .myTenants()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response) => {
        if (!response.success) {
          return;
        }

        const tenants = response.data ?? [];
        this.hasMultipleTenants = response.page.total > 1;
        this.current = tenants.find((tenant) => tenant.current) ?? null;

        this._changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  openSwitchModal(): void {
    this._dialog
      .open(TenantSwitchModalComponent, {
        width: "640px",
        maxWidth: "90vw",
        data: { current: this.current },
      })
      .afterClosed()
      .subscribe((selected: TenantOption | undefined) => {
        if (!selected) {
          return;
        }

        this._authService.selectTenant(selected.id).subscribe((response) => {
          if (!response.success) {
            return;
          }

          localStorage.removeItem("activeEstabelecimento");

          // Já define a empresa ativa do novo tenant antes do reload; senão o
          // seletor do header escolhe a primeira depois e recarrega de novo.
          this._authService.selecionarPrimeiroEstabelecimento().subscribe(() => location.reload());
        });
      });
  }
}
